import React, { useMemo } from 'react';
import CalendarEventCard from './CalendarEventCard';
import {
  DAY_NAMES_FULL,
  FORTNIGHT_DAYS,
  buildDateRange,
  getEventsForDay,
  isSameCalendarDay,
  toDateKey,
} from '../../utils/calendarHelpers';

function DayColumn({ date, eventsByDate }) {
  const today = new Date();
  const isTodayCol = isSameCalendarDay(date, today);
  const dateKey = toDateKey(date);
  const events = getEventsForDay(eventsByDate, dateKey);
  const dayOfWeek = (date.getDay() + 6) % 7;
  const monthLabel = date.toLocaleDateString('hu-HU', { month: 'long' });

  return (
    <div className={`calendar-week-day${isTodayCol ? ' calendar-week-day--today' : ''}`}>
      <div className="calendar-week-day__head">{DAY_NAMES_FULL[dayOfWeek]}</div>
      <div className="calendar-week-day__date">
        <span className="calendar-week-day__num">{date.getDate()}</span>
        <span className="calendar-week-day__mon">{monthLabel}</span>
      </div>
      <div className="calendar-week-day__events">
        {events.length === 0 ? (
          <p className="calendar-week-day__empty">Nincs program</p>
        ) : (
          events.map((event) => (
            <CalendarEventCard
              key={event.id || `${dateKey}-${event.time}-${event.title}`}
              event={event}
            />
          ))
        )}
      </div>
    </div>
  );
}

function CalendarWeekView({ rangeStart, eventsByDate }) {
  const fortnightDays = useMemo(
    () => buildDateRange(rangeStart, FORTNIGHT_DAYS),
    [rangeStart]
  );

  return (
    <div className="calendar-week-scroll">
      <div className="calendar-week-board">
        {fortnightDays.map((date) => (
          <DayColumn key={toDateKey(date)} date={date} eventsByDate={eventsByDate} />
        ))}
      </div>
    </div>
  );
}

export default CalendarWeekView;
